(() => {
  if (window.nsHalloweenCampaign) return;
  window.nsHalloweenCampaign = true;
  const rootSelector = '[data-ns-component]';
  const qs = (s) => document.querySelector(s);
  const qsa = (s) => [...document.querySelectorAll(s)];
  function updateTimers() {
    qsa(`${rootSelector} [data-ns-sale-countdown]`).forEach(timer => {
      const value = timer.dataset.end || '';
      const deadline = /T.*(?:Z|[+-]\d{2}:\d{2})$/.test(value) ? Date.parse(value) : NaN;
      const seconds = Math.ceil((deadline - Date.now()) / 1000);
      if (!Number.isFinite(seconds) || seconds <= 0) { timer.hidden = true; return; }
      const units = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
      Object.entries(units).forEach(([key,number]) => {
        const node = timer.querySelector(`[data-time="${key}"]`);
        if (node) node.textContent = String(number).padStart(2,'0');
      });
      const label = timer.querySelector('[data-ns-sale-end-label]');
      if (label && label.dateTime !== value) {
        label.dateTime = value;
        label.textContent = 'Ends ' + new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/London',day:'numeric',month:'short',year:'numeric',hour:'2-digit',minute:'2-digit',timeZoneName:'short'}).format(deadline);
      }
      timer.hidden = false;
    });
  }
  function init() {
    if (!qs(rootSelector)) return;
    document.body.classList.add('ns-summer-sale-page');
    updateTimers();
    // Editing must show the merchant's section values, not override them with ad copy.
    if (window.Shopify?.designMode) return;
    const key = new URLSearchParams(location.search).get('offer');
    const card = qsa(`${rootSelector} .ns-summer__deal-card`).find(el => el.dataset.offer === key);
    const cta = qs(`${rootSelector} [data-ns-hero-cta]`);
    if (!card || !cta || cta.dataset.personalize !== 'true') return;
    const hero = cta.closest(rootSelector);
    [['[data-ns-hero-prefix]','adPrefix'],['[data-ns-hero-value]','adHeading'],['[data-ns-hero-lead]','adLead']].forEach(([selector,field]) => {
      const el = hero.querySelector(selector);
      if (el && card.dataset[field]) el.textContent = card.dataset[field];
    });
    const value = hero.querySelector('[data-ns-hero-value]');
    if (value && value.textContent.length > 12) value.style.fontSize = 'clamp(36px,7vw,80px)';
    if (card.dataset.adButton) cta.textContent = card.dataset.adButton + ' ↗';
    cta.href = card.getAttribute('href');
    cta.dataset.offer = key;
    card.classList.add('is-ad-selected');
    const sticky = qs(`${rootSelector} [data-ns-sticky-cta]`);
    if (sticky) { sticky.href = card.getAttribute('href'); sticky.dataset.offer = key; sticky.textContent = 'VIEW OFFER'; }
    const title = qs(`${rootSelector} [data-ns-sticky-title]`);
    if (title) title.textContent = [card.dataset.adPrefix,card.dataset.adHeading].filter(Boolean).join(' ');
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (!link || !link.closest(rootSelector)) return;
    const href = link.getAttribute('href') || '';
    if (href.startsWith('#') && href.length > 1) {
      const target = document.getElementById(href.slice(1));
      if (target) { event.preventDefault(); target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'}); }
    }
    if (!window.Shopify?.designMode) {
      const offer = link.dataset.offer || link.closest('[data-offer]')?.dataset.offer || 'all';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event:'ns_summer_offer_click',offer,destination:href});
      document.documentElement.dataset.nsLastOfferClick = offer;
    }
  },true);
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:reorder',init);
  document.addEventListener('shopify:block:select',event => {
    if (event.target.closest(rootSelector)) event.target.scrollIntoView({block:'nearest'});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
  const interval = window.setInterval(updateTimers,1000);
  let attempts = 0;
  const chatInterval = window.setInterval(() => {
    const shadow = qs('shopify-chat')?.shadowRoot;
    if (shadow && !shadow.querySelector('#ns-summer-chat-mobile-style')) {
      const style = document.createElement('style');
      style.id = 'ns-summer-chat-mobile-style';
      style.textContent = '@media(max-width:699px){.activator-nudge{left:8px!important;bottom:82px!important;width:44px!important;height:44px!important}.activator{width:44px!important;height:44px!important;min-width:44px!important;padding:0!important;display:grid!important;place-items:center!important}.activator__label{display:none!important}}';
      shadow.append(style);
      clearInterval(chatInterval);
    }
    if (++attempts >= 40) clearInterval(chatInterval);
  },250);
  window.addEventListener('pagehide',event => { if (!event.persisted) { clearInterval(interval); clearInterval(chatInterval); } });
})();
